import {
  Box,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIconProps,
  SxProps,
  Typography,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface MenuItemProps {
  icon: React.ComponentType<SvgIconProps>;
  iconColor?: string;
  iconBg?: string;
  label: string;
  value?: string;
  onClick?: () => void;
  hideIcon?: boolean;
  showDivider?: boolean;
  isDanger?: boolean;
  sx?: SxProps;
}

export function MenuItem({
  icon: Icon,
  iconColor,
  iconBg,
  label,
  value,
  onClick,
  hideIcon,
  showDivider,
  isDanger,
  sx,
}: MenuItemProps) {
  const defaultIconColor = isDanger ? "#E55353" : iconColor || "#C48C3A";
  const defaultIconBg = isDanger
    ? "rgba(229, 83, 83, 0.12)"
    : iconBg || "rgba(196, 140, 58, 0.12)";

  return (
    <>
      <ListItemButton
        onClick={onClick}
        sx={{
          py: 1.3,
          px: 2,
          display: "flex",
          alignItems: "center",
          borderRadius: 0,
          transition: "background-color 0.15s ease",
          "&:hover": {
            bgcolor: "action.hover",
          },
          "&:active": {
            bgcolor: "action.selected",
          },
          ...sx,
        }}
      >
        <ListItemIcon sx={{ minWidth: 44 }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "8px",
              bgcolor: defaultIconBg,
              color: defaultIconColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <Icon sx={{ fontSize: 20 }} />
          </Box>
        </ListItemIcon>
        <ListItemText
          primary={label}
          primaryTypographyProps={{
            variant: "body1",
            fontWeight: 500,
            fontSize: "0.95rem",
            color: isDanger ? "error.main" : "text.primary",
          }}
        />
        {value && (
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", mr: hideIcon ? 0 : 0.8 }}
          >
            {value}
          </Typography>
        )}
        {!hideIcon && (
          <ChevronRightIcon
            sx={{ color: "text.disabled", fontSize: 20, opacity: 0.7 }}
          />
        )}
      </ListItemButton>
      {showDivider && (
        <Divider
          sx={{
            ml: "56px",
            borderColor: "divider",
          }}
        />
      )}
    </>
  );
}
